import getObjectValues from "../../../../../utils/getObjectValues";

const MenuTranslationsDictionary = {
    Dashboard: "Dashboard",
    HOS: "HOS",
    WorkDiary: "Work Diary",
    AssetInspection: "Asset Inspection",
    Messages: "Messages",
    Trips: "Trips",
    Settings: "Settings"
};

export const MenuTranslations = getObjectValues(MenuTranslationsDictionary);
export default MenuTranslationsDictionary;